import { Types } from "@grandvisionhq/graphql";
function getPrescriptionGlassesDetails(prescription) {
  switch (prescription.type) {
    case "email-prescription":
      return {
        isEmailPrescription: true
      };
    case "existing-customer":
      return {
        isExistingCustomer: true
      };
    case "new-prescription":
      return {
        newPrescription: {
          ...prescription.details
        }
      };
    case "prescription-file": {
      const { prescriptionFile, pupillaryDistanceFile, left, right, source } = prescription.details;
      const leftLens = { ...left };
      if (leftLens.axisInt) {
        leftLens.axis = leftLens.axisInt;
        delete leftLens.axisInt;
      }
      const rightLens = { ...right };
      if (rightLens.axisInt) {
        rightLens.axis = rightLens.axisInt;
        delete rightLens.axisInt;
      }
      const newPrescription = Boolean(left && right) ? {
        leftLens,
        rightLens,
        source
      } : { source };
      return {
        newPrescription,
        prescriptionFile: {
          fileName: prescriptionFile.fileName,
          storageToken: prescriptionFile.storageToken
        },
        pupillaryDistanceFile: pupillaryDistanceFile ? {
          fileName: pupillaryDistanceFile.fileName,
          storageToken: pupillaryDistanceFile.storageToken
        } : void 0
      };
    }
  }
}
const mapPrescriptionGlassesLineItem = ({
  sku,
  quantity,
  bundleLineItems,
  prescription
}) => {
  const mainBundleLineItem = {
    sku,
    quantity: 1,
    // The quantity of the entire bundle is indicated on the root level of the bundle.
    isMainBundleLineItem: true
  };
  return {
    sku,
    quantity: quantity ?? 1,
    lineItemType: Types.LineItemType.BUNDLE,
    bundleLineItemsType: Types.BundleLineItemType.PRESCRIPTION_GLASSES,
    bundleLineItems: [
      mainBundleLineItem,
      ...bundleLineItems.map((item) => ({
        ...item,
        quantity: item.quantity ?? 1,
        isMainBundleLineItem: false
      }))
    ],
    typeDetails: getPrescriptionGlassesDetails(prescription)
  };
};
export {
  mapPrescriptionGlassesLineItem
};
//# sourceMappingURL=prescription-glasses.js.map
